import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-10" }
const _hoisted_5 = { class: "settings-tabs ps-0 mb-0 list-unstyled" }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 mb-4" }
const _hoisted_10 = { class: "d-flex align-items-center gap-3" }
const _hoisted_11 = { class: "image position-relative" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "form-group mb-0" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/account-settings",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" Account Settings ", -1)
                ])),
                _: 1,
                __: [9]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-statuts",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Status ", -1)
                ])),
                _: 1,
                __: [10]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-type-clients",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("Types des clients ", -1)
                ])),
                _: 1,
                __: [11]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-banks",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("Liste des banques ", -1)
                ])),
                _: 1,
                __: [12]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-social-links",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("Lien social ", -1)
                ])),
                _: 1,
                __: [13]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-transports",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode(" Transports ", -1)
                ])),
                _: 1,
                __: [14]
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: _ctx.logoPreview || require('@/assets/images/NoImage.png'),
                      class: "rounded-circle",
                      width: "85",
                      height: "85"
                    }, null, 8, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Importer votre logo ", -1)),
                    _createElementVNode("input", {
                      class: "form-control fs-15 text-black shadow-none",
                      type: "file",
                      id: "formFile",
                      accept: "image/*",
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChangeLogo && _ctx.onFileChangeLogo(...args)))
                    }, null, 32)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nom de la société ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': _ctx.errors.name }]),
                    placeholder: "e.g. Acme Corp",
                    maxlength: "100",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settingData.name) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.settingData.name]
                  ]),
                  (_ctx.errors.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.errors.name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Site web ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "url",
                    class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': _ctx.errors.website }]),
                    placeholder: "https://example.com",
                    maxlength: "255",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settingData.website) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.settingData.website]
                  ]),
                  (_ctx.errors.website)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.errors.website), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Email ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': _ctx.errors.email }]),
                    placeholder: "contact@example.com",
                    maxlength: "150",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settingData.email) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.settingData.email]
                  ]),
                  (_ctx.errors.email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.errors.email), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Téléphone ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-invalid': _ctx.errors.phone }]),
                    placeholder: "+212 600 000000",
                    maxlength: "20",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settingData.phone) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.settingData.phone]
                  ]),
                  (_ctx.errors.phone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.errors.phone), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Ville ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select shadow-none fw-semibold rounded-0",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settingData.siege) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.id,
                        value: option.name
                      }, _toDisplayString(option.name), 9, _hoisted_28))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.settingData.siege]
                  ])
                ])
              ]),
              _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Choisir votre devis </label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option value=\"MAD\">MAD</option><option value=\"EUR\">EUR</option><option value=\"USD\">USD</option></select></div></div>", 1)),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Adresse ", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control shadow-none fs-md-15 text-black",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settingData.adresse) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.settingData.adresse]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Les conditions générales ", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    rows: "15",
                    class: "form-control shadow-none fs-md-15 text-black",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settingData.conditions) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.settingData.conditions]
                  ])
                ])
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                  _createElementVNode("button", {
                    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                    type: "submit"
                  }, " Enregistrer ")
                ])
              ], -1))
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}